export default __webpack_public_path__ + "static/media/galluium.701773b6.png";